import { TFunction } from "i18next";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger } from "shared/components/Spor";

export const getVehicleListTabs = (
  translate: TFunction<"translation", undefined>,
) =>
  [
    {
      value: translate("Tog"),
      label: translate("Søk på tognr, stasjon, linjenr eller sett-ID"),
    },
    {
      value: translate("Buss"),
      label: translate("Søk på skiftnr, stasjon, tlfnr eller tognr"),
    },
    {
      value: translate("Reservebuss"),
      label: translate("Søk på skiftnr, stasjon eller tlfnr"),
    },
  ] as const;

type VehicleTabsProps = {
  onChange: (index: number) => void;
};

const VehicleTabs: FC<VehicleTabsProps> = ({ onChange }) => {
  const { t } = useTranslation();
  const vehicleListTabs = getVehicleListTabs(t);
  return (
    <Tabs
      variant="core"
      onValueChange={(e: { value: string }) =>
        onChange(vehicleListTabs.findIndex(({ value }) => value === e.value))
      }
      colorScheme="base"
      fitted
      mb="12px"
      width="max-content"
    >
      <TabsList>
        {vehicleListTabs.map((tab, index) => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            aria-controls={`Tabs-:ra:--TabsContent-${index}`}
          >
            {tab.value}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};

export default VehicleTabs;
